import { B as l, j as e, T as c } from "./Spinner-dTAYYnIx.js";
import { S as x } from "./Section-cF107_Su.js";
import { D as o } from "./domPurify-ugx5Lmst.js";
import { styled as n } from "styled-components";
import { C as d } from "./Container-acMbkeg4.js";
import { e as f, f as h } from "./index-QRkynDgW.js";
import { T as y } from "./typography.styled-aDVGHct9.js";
import { T as a } from "./style-8UHgYe1v.js";
const s = n(y)`
  appearance: none;
  text-align: center;
`, T = n(l)`
  margin-top: ${f.spacer4};
`, g = n(d)`
  ${h}
`, j = ({ cta: r, title: i, theme: m, subtitle: t, componentName: p }) => /* @__PURE__ */ e.jsx(c, { theme: m, children: /* @__PURE__ */ e.jsx(x, { "data-qa": p, children: /* @__PURE__ */ e.jsxs(g, { $flexDirection: "column", $alignItems: "center", children: [
  /* @__PURE__ */ e.jsx(
    s,
    {
      as: "p",
      $variant: a.headingLSerif,
      dangerouslySetInnerHTML: { __html: o(i, "inlineRichtext") }
    }
  ),
  t && /* @__PURE__ */ e.jsx(
    s,
    {
      as: "p",
      $variant: a.bodyS,
      dangerouslySetInnerHTML: { __html: o(t, "inlineRichtext") },
      $mt: { xs: "spacer5", md: "spacer2" },
      $mb: "spacer4"
    }
  ),
  (r == null ? void 0 : r.children) && /* @__PURE__ */ e.jsx(T, { ...r, variant: r.variant ?? "secondary" })
] }) }) }), C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextBanner: j
}, Symbol.toStringTag, { value: "Module" }));
export {
  j as T,
  C as i
};
